/**
 * Generate 4 length random string
 *
 * @returns {string} - string
 */
function s4() {
  return Math.floor((1 + Math.random()) * 0x10000)
    .toString(16)
    .slice(1);
}

/**
 * Generate a unique identifier
 *
 * @returns {string} A unique identifier
 * @memberof Internal
 */
function guid() {
  return `${s4() + s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`;
}

export default guid;
